import { useCallback, useMemo, useState } from 'react'
import { useConnectors } from './useConnectors'
import type { ConnectorType } from '@/types'

export function useConnectionChoice(projectId: string, connectorType: ConnectorType) {
  const { data: connectors = [], isLoading } = useConnectors(projectId)
  const [chosenId, setChosenId] = useState('')

  const connections = useMemo(
    () => connectors.filter(c => c.type === connectorType && c.isEnabled),
    [connectors, connectorType],
  )

  const needsChoice = connections.length > 1
  const selectedId = needsChoice && connections.some(c => c.id === chosenId) ? chosenId : ''

  const reset = useCallback(() => setChosenId(''), [])

  const usedConnection = connections.find(c => c.id === selectedId) ?? (connections.length === 1 ? connections[0] : undefined)

  return {
    connections,
    isLoading,
    needsChoice,
    selectedId,
    selectedName: usedConnection?.connectionName,
    usedConnectionId: usedConnection?.id,
    connectorId: selectedId || undefined,
    isChoiceMissing: needsChoice && !selectedId,
    select: setChosenId,
    reset,
  }
}
